import {NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {MatIconModule} from '@angular/material/icon';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FlexLayoutModule} from '@angular/flex-layout';
import {ContactComponent} from './contact/contact.component';
import {HomeComponent} from './home/home.component';
import {TeamComponent} from './team/team.component';
import {VisitCardComponent} from './visit-card/visit-card.component';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatListModule} from '@angular/material/list';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatExpansionModule} from '@angular/material/expansion';
import {ExaminationComponent} from './examination/examination.component';
import {ServicesComponent} from './services/services.component';
import {VasektomieComponent} from './vasektomie/vasektomie.component';
import {HashLocationStrategy, LocationStrategy} from '@angular/common';
import {MatTooltipModule} from '@angular/material/tooltip';
import {ImpressumComponent} from "./impressum/impressum.component";

@NgModule({
  declarations: [
    AppComponent,
    ContactComponent,
    TeamComponent,
    HomeComponent,
    VisitCardComponent,
    ExaminationComponent,
    ServicesComponent,
    VasektomieComponent,
    ImpressumComponent
  ],
  imports: [
    BrowserAnimationsModule,
    AppRoutingModule,
    MatIconModule,
    MatToolbarModule,
    MatButtonModule,
    MatListModule,
    MatSidenavModule,
    MatExpansionModule,
    FlexLayoutModule,
    MatTooltipModule,
    MatCardModule
  ],
  providers: [Location, {provide: LocationStrategy, useClass: HashLocationStrategy}],
  bootstrap: [AppComponent]
})
export class AppModule { }
